import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

interface ProfileHeaderProps {
	imageUrl: string;
	name: string;
	ratingInfo?: string;
	isVerified?: boolean;
}

function ProfileHeader({
	imageUrl,
	name
}: ProfileHeaderProps) {
	return (
		<div className="flex items-center space-x-4">
			<div className="relative">
				<div className="absolute -right-2 top-2 rounded-full bg-primary p-1.5 z-50">
					<img src="/intasida-icon.svg" alt="" className="size-4" />
				</div>
				<Avatar className="size-24 border-4 border-primary">
					<AvatarImage className="object-fill" src={imageUrl} alt={name} />
					<AvatarFallback className="capitalize font-medium text-2xl">{name.charAt(0)}</AvatarFallback>
				</Avatar>
			</div>
		</div>
	);
}

export default ProfileHeader;
